module.exports = __webpack_public_path__ + "img/Weapon_105.ecd2e6fd.png";